// src/pages/Menu/MenuSection/MenuRadioSection.tsx
import React, { FC, ReactElement } from "react";
import { Radio, Row, Typography } from "antd";
import { PerfumePrice } from "../../../types/types"; // <-- corrected path

type PropsType = {
  title: string;
  data: PerfumePrice[];
  onChange: (event: any) => void;
};

const MenuRadioSection: FC<PropsType> = ({ title, data, onChange }): ReactElement => {
  return (
    <div>
      <Typography.Title level={5} style={{ marginTop: 8 }}>
        {title}
      </Typography.Title>
      <Radio.Group onChange={onChange} style={{ width: "100%" }}>
        {data.map((price) => (
          <Row key={price.id}>
            <Radio value={price}>{price.name}</Radio>
          </Row>
        ))}
      </Radio.Group>
    </div>
  );
};

export default MenuRadioSection;
